import util from '@/libs/util'

const post = util.ajax.post

export const messagemain = {}

messagemain.list = function (params) {
  return post('/msg/listMsgDefinition', params)
}
messagemain.listById = function (params) {
  return post('/msg/msgInfoGet', params)
}
messagemain.deleteById = function (params) {
  return post('/msg/deleteMsg', params)
}
messagemain.pushMsg = function (params) {
  return post('/msg/pushMsg', params)
}
messagemain.AddOrUpdate = function (params) {
  return post('/msg/msgCreateOrEdit', params)
}
messagemain.uploadFile = function (params) {
  return post('/file/uploadFile', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/message/messagemain.js